import { Grid, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import * as assetApi from '../../api/app/assetApi';
import { ApiError } from '../../components/core/ApiError/ApiError';
import { Loader } from '../../components/core/Loader/Loader';
import { SelectBoxAutocompleteAsync } from '../../components/core/SelectBox/SelectBoxAutocompleteAsync';
import { useTranslation } from '../../contexts/translation';
import { Asset } from '../../types/app/asset.types';
import { EmailReportUserInputs } from '../../types/app/emailReportUser.types';
interface Props {
  onSubmit: SubmitHandler<EmailReportUserInputs>;
  defaultValues?: EmailReportUserInputs;
  onBack: any;
  isReadOnly?: boolean;
}

export function EmailReportUserForm({ onSubmit, defaultValues, onBack, isReadOnly }: Props) {
  const { t } = useTranslation();
  const {
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm<EmailReportUserInputs>();

  const {
    data: assetList,
    isLoading: assetListIsLoading,
    isError: assetListIsError,
  } = useQuery<Asset[]>(['assets'], () => assetApi.getAssetList());

  useEffect(() => {
    reset({ ...defaultValues });
  }, [defaultValues, reset]);

  if (assetListIsError) return <ApiError />;
  if (assetListIsLoading || !assetList) return <Loader />;

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <SelectBoxAutocompleteAsync
              isRequired
              label={'Username'}
              valueKey={'userId'}
              labelKey={'fullName'}
              controllerProps={{
                name: 'userId',
                control: control,
                rules: { required: 'Name is required.' },
                defaultValues: defaultValues?.userFullName,
              }}
              errors={errors}
            />
          </Grid>
          <Grid item>
            <Stack spacing={2} direction="row">
              <Button type="button" variant="outlined" onClick={onBack}>
                {t('general.action-buttons.back')}
              </Button>
              {!isReadOnly && (
                <Button type="submit" variant="contained" color="success">
                  {t('general.action-buttons.save')}
                </Button>
              )}
            </Stack>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
